import axios from 'axios';
import { PartnerStore } from '../models/PartnerStore';
import { PartnerStoreRequest } from '../models/PartnerStoreRequest';

const API_URL = process.env.REACT_APP_API_URL;
const PARTNER_STORES_PATH = '/api/partner-stores/';

export function listPartnerStores(): Promise<{ data: Array<any> }> {
  const endpoint = `${API_URL}${PARTNER_STORES_PATH}`;

  return axios.get(endpoint);
}

export function createPartnerStore(
  request: PartnerStoreRequest
): Promise<{ data: PartnerStore }> {
  const endpoint = `${API_URL}${PARTNER_STORES_PATH}`;
  const formData = new FormData();

  formData.append('image', request.image || '');
  formData.append('store', request.store.toString());
  formData.append('name', request.name);
  formData.append('description', request.description);
  formData.append('benefit', request.benefit);
  formData.append('coupon', request.coupon || '');
  formData.append('href', request.href);

  return axios.post(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function updatePartnerStore(
  partnerStoreId: number,
  partnerStore: PartnerStoreRequest
): Promise<{ data: PartnerStore }> {
  const endpoint = `${API_URL}${PARTNER_STORES_PATH}${partnerStoreId}/`;
  const formData = new FormData();

  formData.append('store', partnerStore.store.toString());
  formData.append('name', partnerStore.name);
  formData.append('description', partnerStore.description);
  formData.append('benefit', partnerStore.benefit);
  formData.append('coupon', partnerStore.coupon || '');
  formData.append('href', partnerStore.href);

  return axios.patch(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function removePartnerStore(
  partnerStoreId: number
): Promise<{ data: any }> {
  const endpoint = `${API_URL}${PARTNER_STORES_PATH}${partnerStoreId}/`;

  return axios.delete(endpoint);
}
